import { useLocation } from "react-router-dom";

export const useCanonicalLink = () => {

    const location = useLocation();

    // Build canonical URL: https without www. and with trailing slash
    let origin = window.location.origin;
    // Always use https
    origin = origin.replace(/^http:/, 'https:');
    // Remove www.
    origin = origin.replace(/\/\/www\./, '//');
    // Get pathname and ensure trailing slash
    let pathname = location.pathname;
    if (!pathname.endsWith('/')) {
        pathname = pathname + '/';
    }
    return origin + pathname;

};